import React from 'react';
import SlackIntegration from './integrations/SlackIntegration';
import EmailIntegration from './integrations/EmailIntegration';
import DestinationsIntegration from './integrations/DestinationsIntegration';

const Badge: React.FC<{ label: string; tone?: 'info' | 'success' | 'warning'; }> = ({ label, tone = 'info' }) => {
  const map: Record<string, string> = {
    info: 'bg-blue-100 text-blue-800',
    success: 'bg-green-100 text-green-800',
    warning: 'bg-yellow-100 text-yellow-800',
  };
  return <span className={`inline-flex items-center rounded px-2 py-0.5 text-xs font-medium ${map[tone]}`}>{label}</span>;
};

const Card: React.FC<{ title: string; description: string; footer?: React.ReactNode }>
  = ({ title, description, footer }) => (
  <div className="rounded-lg border bg-white p-4 shadow-sm flex flex-col gap-3">
    <div className="flex items-center justify-between">
      <h3 className="text-base font-semibold text-gray-900">{title}</h3>
      <Badge label="Coming soon" tone="info" />
    </div>
    <p className="text-sm text-gray-600">{description}</p>
    {footer && <div className="pt-2 border-t">{footer}</div>}
  </div>
);

const IntegrationsHub: React.FC = () => {
  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Integrations</h2>
      <p className="text-gray-600 mb-6">
        Connect external tools to enhance automation and analytics. Were building native integrations
        for notifications (Slack/Email) and data pipelines (Segment/CRM). In the meantime, you can
        use Webhooks to receive real-time events.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <SlackIntegration />
        <EmailIntegration />
        <DestinationsIntegration />
        <Card
          title="Webhooks"
          description="Already available: create webhook endpoints to receive real-time conversion and payout events."
          footer={<a href="#" onClick={(e) => { e.preventDefault(); document.getElementById('nav-webhooks')?.click(); }} className="text-blue-600 hover:underline">Manage Webhooks</a>}
        />
      </div>

      <div className="rounded-md border border-blue-200 bg-blue-50 p-4">
        <p className="text-sm text-blue-800">
          Tip: Use API keys and the webhook delivery system (Admin &gt; Webhooks) to start integrating today. Slack/Email and Segment/CRM UIs will land here without breaking changes.
        </p>
      </div>
    </div>
  );
};

export default IntegrationsHub;
